import { Row, Col, InputGroup, Form, Button } from "react-bootstrap";
import {
  BsTextareaT,
  BsFillHouseFill,
  BsBagFill,
  BsFillSignpostFill,
  Bs123,
  BsBank2,
  BsFillSignTurnRightFill,
  BsFillSignpostSplitFill,
  BsFillPinMapFill,
  BsFillPinAngleFill,
  BsFilePerson,
  BsFillPeopleFill,
  BsFillTelephoneInboundFill,
  BsFillEnvelopeAtFill,
  BsGrid,
  BsGrid1X2,
  BsFillFloppy2Fill,
  BsFillCheckCircleFill,
  BsFillExclamationTriangleFill,
  BsMegaphoneFill,
} from "react-icons/bs";
import Modal from "react-bootstrap/Modal";
/* En tu componente principal (App.js) */
import "bootstrap/dist/css/bootstrap.min.css"; // Primero Bootstrap
import "../../App.css";
import Accordion from "react-bootstrap/Accordion";
import "bootstrap/dist/css/bootstrap.min.css";

import ReCAPTCHA from "react-google-recaptcha";

import HeaderComponent from "../modulos/HeaderComponent";
import FooterComponent from "../modulos/FooterComponent";

import React, { useState, useEffect, useRef } from "react";

import {
  getMunicipios,
  getLocalidadesByMunicipio,
  getActividades,
  getSubactividadesByActividad,
  registrarQueja,
  getGenero,
} from "../../services/apiService";

const AddQuejaComponent = () => {
  document.title = "Registro Denuncia | SIDEC";

  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const recaptchaRef = useRef();

  // Resetear el input file
  const ref = useRef();
  const reset = () => {
    ref.current.value = "";
  };
  ////////////////////
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [quejaId, setQuejaId] = useState(null); // Nuevo estado para el ID de la queja
  const [quejaFolio, setQuejaFolio] = useState(null);
  // Modifica los manejadores del modal existente
  const handleCloseSuccess = () => setShowSuccess(false);
  const handleShowSuccess = () => setShowSuccess(true);

  const handleCloseError = () => setShowError(false);
  const handleShowError = (message) => {
    setModalMessage(message);
    setShowError(true);
  };

  ////////////////////////////////

  const [municipios, setMunicipios] = useState([]);
  const [actividades, setActividades] = useState([]);
  const [subactividades, setSubactividades] = useState([]);

  const [localidades1, setLocalidades1] = useState([]);
  const [localidades2, setLocalidades2] = useState([]);

  const [formData, setFormData] = useState({
    dqueja: "",
    actividadId: "",
    subactividadId: "",
    einstitucion: "",
    eginstitucion: "",
    ecalle: "",
    enumero: "",
    ecolonia: "",
    ecalles: "",
    ereferencia: "",
    municipioId: "",
    municipioId2: "",
    localidadId: "",
    localidadId2: "",
    dnombre: "",
    generoId: "",
    dtelefono: "",
    dcorreo: "",
    dcorreos: "",
    fecha: "",
    file: null,
    notificacion: "No",
  });

  // Género
  const [genero, setGenero] = useState([]);

  // Cargar Género
  useEffect(() => {
    const fetchData = async () => {
      try {
        const generoData = await getGenero();
        setGenero(generoData);
      } catch (error) {
        console.error("Error al cargar datos iniciales:", error);
      }
    };

    fetchData();
  }, []);

  // end genero

  // Cargar municipios y actividades al iniciar
  useEffect(() => {
    const fetchData = async () => {
      try {
        const municipiosData = await getMunicipios();
        setMunicipios(municipiosData);

        const actividadesData = await getActividades();
        setActividades(actividadesData);
      } catch (error) {
        console.error("Error al cargar datos iniciales:", error);
      }
    };

    fetchData();
  }, []);
  // Cargar municipios denunciante
  useEffect(() => {
    const fetchData = async () => {
      try {
        const municipiosData = await getMunicipios();
        setMunicipios(municipiosData);
      } catch (error) {
        console.error("Error al cargar datos iniciales:", error);
      }
    };

    fetchData();
  }, []);
  const handleMunicipioChange = async (e) => {
    const municipioId = e.target.value;
    setFormData({ ...formData, municipioId, localidadId: "" });

    try {
      const localidadesData = await getLocalidadesByMunicipio(municipioId);
      setLocalidades1(localidadesData); // Usamos setLocalidades1 en la primera sección
    } catch (error) {
      console.error("Error al cargar localidades:", error);
    }
  };
  const handleMunicipioChange2 = async (e) => {
    const municipioId1 = e.target.value;
    setFormData({ ...formData, municipioId1, localidadId2: "" });

    try {
      const localidadesData = await getLocalidadesByMunicipio(municipioId1);
      setLocalidades2(localidadesData); // Usamos setLocalidades2 en la segunda sección
    } catch (error) {
      console.error("Error al cargar localidades:", error);
    }
  };
  // Cargar municipios denunciante
  useEffect(() => {
    const fetchData = async () => {
      try {
        const municipiosData = await getMunicipios();
        setMunicipios(municipiosData);
      } catch (error) {
        console.error("Error al cargar datos iniciales:", error);
      }
    };

    fetchData();
  }, []);
  // Manejar cambio de actividad y cargar subactividades
  const handleActividadChange = async (e) => {
    const actividadId = e.target.value;
    setFormData({ ...formData, actividadId, subactividadId: "" });

    try {
      const subactividadesData = await getSubactividadesByActividad(
        actividadId
      );
      setSubactividades(subactividadesData);
    } catch (error) {
      console.error("Error al cargar subactividades:", error);
    }
  };

  // Manejar cambios generales en el formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Sanitización especial para el teléfono
    if (name === "dtelefono") {
      const numericValue = value.replace(/\D/g, "");
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
      return;
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      // Validar tipo de archivo
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
      const maxSizeMB = 19;
      const maxSizeBytes = maxSizeMB * 1024 * 1024; // 19MB en bytes

      if (!allowedTypes.includes(file.type)) {
        handleShowError("Solo se permiten archivos JPG, PNG o PDF");
        reset();
        return;
      }

      if (file.size > maxSizeBytes) {
        handleShowError(`El archivo excede el límite de ${maxSizeMB}MB`);
        reset();
        return;
      }

      setFormData((prev) => ({ ...prev, file }));
    }
  };

  ///////////////////APARTADO PARA CAMPOS OBLIGATORIOS/////////////////////////////////

  const getFieldError = (fieldName) => {
    if (!submitAttempted) return null; // Solo muestra errores después de intentar enviar

    const value = formData[fieldName];

    if (requiredFields.includes(fieldName)) {
      if (typeof value === "string" && !value.trim()) {
        return "Este campo es obligatorio";
      }
      if (!value) return "Este campo es obligatorio";
    }

    // Validación específica para teléfono
    if (fieldName === "dtelefono") {
      if (!/^\d+$/.test(value)) {
        return "Solo se permiten números";
      }
      if (value.length < 10) {
        // Ejemplo: validación de 10 dígitos
        return "Debe tener al menos 10 dígitos";
      }
    }

    if (
      fieldName === "dcorreo" &&
      value &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ) {
      return "Correo electrónico inválido ";
    }

    return null;
  };
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const requiredFields = [
    "dqueja",
    "actividadId",
    "subactividadId",
    "einstitucion",
    "eginstitucion",
    "ecalle",
    "enumero",
    "ecolonia",
    "ecalles",
    "ereferencia",
    "municipioId",
    "localidadId",
    "dnombre",
    "generoId",
    "dtelefono",
    "dcorreo",
    "municipioId1",
    "localidadId2",
  ];

  ////////////////////////////////

  // Función para manejar el cambio del reCAPTCHA
  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  // Envio del formulario
  const handleSubmit = async (e) => {
    
    e.preventDefault();
    
    setSubmitAttempted(true);

    if (!recaptchaValue) {
      handleShowError(
        "Por favor complete el reCAPTCHA para demostrar que no es un robot"
      );
      return;
    }

    const allFieldsValid = requiredFields.every((field) => {
      const value = formData[field];
      return typeof value === "string" ? value.trim() !== "" : !!value;
    });

    const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.dcorreo);

    if (!allFieldsValid || !emailValido) {
      handleShowError(
        "Por favor complete todos los campos requeridos correctamente"
      );
      return;
    }

    const quejaData = {
      dqueja: formData.dqueja,
      subActividadId: formData.subactividadId,
      einstitucion: formData.einstitucion,
      eginstitucion: formData.eginstitucion,
      ecalle: formData.ecalle,
      enumero: formData.enumero,
      ecolonia: formData.ecolonia,
      ecalles: formData.ecalles,
      ereferencia: formData.ereferencia,
      localidadId: formData.localidadId,
      dlocalidad: formData.localidadId2,
      dnombre: formData.dnombre,
      generoId: formData.generoId,
      dtelefono: formData.dtelefono,
      dcorreo: formData.dcorreo,
      notificacion: formData.notificacion,
    };

    const data = new FormData();
    data.append("queja", JSON.stringify(quejaData));
    data.append("recaptchaToken", recaptchaValue);
    if (formData.file) {
      data.append("file", formData.file);
    }

    setLoading(true);
    try {
      const response = await registrarQueja(data);
      // Asume que la respuesta incluye el ID de la queja en response.id
      setQuejaId(response.id); // Almacena el ID de la queja
      setQuejaFolio(response.folio);
      handleShowSuccess();
      // Resto del código para limpiar el formulario...
    } catch (error) {
      console.error("Error al registrar la queja:", error);
      handleShowError(
        "Hubo un error al enviar la queja. Por favor intente nuevamente."
      );
    }
    finally {

      setLoading(false);

    }
  };

  return (
    <div
      style={{
        //backgroundImage:"url(https://www.veracruz.gob.mx/proteccioncivil/wp-content/uploads/sites/5/2024/12/459029599_938750401627993_9216811163148847696_n.jpg)",
        backgroundImage: "url(/background2.jpeg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Modal de éxito */}

      <Modal show={showSuccess} onHide={handleCloseSuccess} centered>
        <Modal.Header closeButton className="bg-success text-white">
          <Modal.Title>
            <BsFillCheckCircleFill className="me-2" />
            Éxito
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-responsive-body">
            <h5>¡Queja registrada exitosamente!</h5>
            <p>Le agradecemos por su tiempo.</p>
            <p>Número de folio: {quejaFolio}</p>
            <p className="rojo">
              Conserve este número y presione el botón detalle
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleCloseSuccess}>
            Cerrar
          </Button> */}
          {quejaId && (
            <Button
              variant="primary"
              onClick={() =>
                (window.location.href = `/resumen-queja/${quejaId}`)
              }
            >
              Ver Detalle
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      {/* Modal de error */}
      <Modal show={showError} onHide={handleCloseError} centered>
        <Modal.Header closeButton className="bg-danger text-white">
          <Modal.Title>
            <BsFillExclamationTriangleFill className="me-2" />
            Aviso
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <HeaderComponent />
      <br />
      <div
        className="container"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.90)",
          borderRadius: "10px",
          padding: "20px",
          marginBottom: "20px",
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
          //maxHeight: "calc(100vh - 200px)", // Ajusta según necesidades
          //overflowY: "auto", // Habilita scroll solo para el formulario
        }}
      >
        <h2 className="text-center text-contrast" style={{ color: "black" }}>
          {" "}
          <BsMegaphoneFill className="me-2" />
          BUZÓN DE QUEJAS Y DENUNCIAS CIUDADANA
        </h2>

        <br />

        <form>
          <Row className="justify-content-center">
            <Col>
              <div className="form-group mb-4">
                <label className="form-label">
                  <b>1.Descripción de la Queja (300 caracteres)</b>
                </label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsTextareaT />
                  </InputGroup.Text>
                  <textarea
                    maxLength={300}
                    placeholder="Escribe una breve descripción de la Queja"
                    className="form-control"
                    name="dqueja"
                    value={formData.dqueja}
                    onChange={handleChange}
                    required
                    autoFocus
                  ></textarea>
                </InputGroup>
                {getFieldError("dqueja") && (
                  <Form.Text className="text-danger">
                    {getFieldError("dqueja")}
                  </Form.Text>
                )}
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col Col xs={12} md={6} lg={6}>
              <div className="form-group mb-2">
                <label className="form-label">Actividad</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text>
                    <BsGrid />
                  </InputGroup.Text>
                  <select
                    className="form-control"
                    name="actividadId"
                    value={formData.actividadId}
                    onChange={handleActividadChange}
                    required
                  >
                    <option value="">-- Selecciona Actividad --</option>
                    {actividades.map((act) => (
                      <option key={act.id} value={act.id}>
                        {act.id} -- {act.actividad}
                      </option>
                    ))}
                  </select>
                </InputGroup>
                {getFieldError("actividadId") && (
                  <Form.Text className="text-danger">
                    {getFieldError("actividadId")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={6}>
              <div className="form-group mb-2">
                <label className="form-label">Especifique</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text>
                    <BsGrid1X2 />
                  </InputGroup.Text>
                  <select
                    className="form-control"
                    name="subactividadId"
                    value={formData.subactividadId}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Selecciona Subactividad --</option>
                    {subactividades.map((sub) => (
                      <option key={sub.id} value={sub.idActividad}>
                        {sub.actividad} -- <b>{sub.riesgo}</b>
                      </option>
                    ))}
                  </select>
                </InputGroup>
                {getFieldError("subactividadId") && (
                  <Form.Text className="text-danger">
                    {getFieldError("subactividadId")}
                  </Form.Text>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Nombre de la Institución</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsBagFill />{" "}
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Se requiere el Nombre o Razón Social"
                    className="form-control"
                    name="einstitucion"
                    value={formData.einstitucion}
                    onChange={handleChange}
                    required
                  >
                  </Form.Control>
                </InputGroup>
                {getFieldError("einstitucion") && (
                  <Form.Text className="text-danger">
                    {getFieldError("einstitucion")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Giro Comercial</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsFillHouseFill />{" "}
                  </InputGroup.Text>
                  <input
                    type="text"
                    placeholder="Giro Comercial del inmueble"
                    name="eginstitucion"
                    className="form-control"
                    value={formData.eginstitucion}
                    onChange={handleChange}
                    required
                  ></input>
                </InputGroup>
                {getFieldError("eginstitucion") && (
                  <Form.Text className="text-danger">
                    {getFieldError("eginstitucion")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Calle</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsFillSignpostFill />{" "}
                  </InputGroup.Text>
                  <input
                    type="text"
                    placeholder="Calle del inmueble"
                    name="ecalle"
                    className="form-control"
                    value={formData.ecalle}
                    onChange={handleChange}
                    required
                  ></input>
                </InputGroup>
                {getFieldError("ecalle") && (
                  <Form.Text className="text-danger">
                    {getFieldError("ecalle")}
                  </Form.Text>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Número</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <Bs123 />
                  </InputGroup.Text>
                  <input
                    type="number"
                    placeholder="Número del inmueble"
                    name="enumero"
                    className="form-control"
                    value={formData.enumero}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
                {getFieldError("enumero") && (
                  <Form.Text className="text-danger">
                    {getFieldError("enumero")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Colonia</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsBank2 />{" "}
                  </InputGroup.Text>
                  <input
                    type="text"
                    placeholder="Colonia del inmueble"
                    name="ecolonia"
                    className="form-control"
                    value={formData.ecolonia}
                    onChange={handleChange}
                    required
                  ></input>
                </InputGroup>
                {getFieldError("ecolonia") && (
                  <Form.Text className="text-danger">
                    {getFieldError("ecolonia")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Entre calles</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsFillSignTurnRightFill />{" "}
                  </InputGroup.Text>
                  <input
                    type="text"
                    placeholder="Entre calles"
                    name="ecalles"
                    className="form-control"
                    value={formData.ecalles}
                    onChange={handleChange}
                    required
                  ></input>
                </InputGroup>
                {getFieldError("ecalles") && (
                  <Form.Text className="text-danger">
                    {getFieldError("ecalles")}
                  </Form.Text>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Referencia</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsFillSignpostSplitFill />{" "}
                  </InputGroup.Text>
                  <input
                    type="text"
                    placeholder="Referencias"
                    name="ereferencia"
                    className="form-control"
                    value={formData.ereferencia}
                    onChange={handleChange}
                    required
                  ></input>
                </InputGroup>
                {getFieldError("ereferencia") && (
                  <Form.Text className="text-danger">
                    {getFieldError("ereferencia")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-2">
                <label className="form-label">Municipio</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text>
                    <BsFillPinMapFill />
                  </InputGroup.Text>
                  <select
                    className="form-control"
                    name="municipioId"
                    value={formData.municipioId}
                    onChange={handleMunicipioChange}
                    required
                  >
                    <option value="">-- Selecciona Municipio --</option>
                    {municipios.map((mun) => (
                      <option key={mun.id} value={mun.id}>
                        {mun.municipio}
                      </option>
                    ))}
                  </select>
                </InputGroup>
                {getFieldError("municipioId") && (
                  <Form.Text className="text-danger">
                    {getFieldError("municipioId")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-2">
                <label className="form-label">Localidad</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text>
                    <BsFillPinAngleFill />
                  </InputGroup.Text>
                  <select
                    name="localidadId"
                    className="form-control"
                    value={formData.localidadId}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Selecciona Localidad --</option>
                    {localidades1.map((loc) => (
                      <option key={loc.id} value={loc.id}>
                        {loc.localidad}
                      </option>
                    ))}
                  </select>
                </InputGroup>
                {getFieldError("localidadId") && (
                  <Form.Text className="text-danger">
                    {getFieldError("localidadId")}
                  </Form.Text>
                )}
              </div>
            </Col>
          </Row>

          <label>
            <b> 2.Datos generales de la persona que registra la queja:</b>
          </label>
          <Row>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Nombre y Apellidos</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsFilePerson />{" "}
                  </InputGroup.Text>
                  <input
                    type="text"
                    placeholder="Digite su nombre"
                    name="dnombre"
                    className="form-control"
                    value={formData.dnombre}
                    onChange={handleChange}
                    required
                  ></input>
                </InputGroup>
                {getFieldError("dnombre") && (
                  <Form.Text className="text-danger">
                    {getFieldError("dnombre")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-2">
                <label className="form-label">Género</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text>
                    <BsFillPeopleFill />
                  </InputGroup.Text>
                  <select
                    name="generoId"
                    className="form-control"
                    value={formData.generoId}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Selecciona Género --</option>
                    {genero.map((loc) => (
                      <option key={loc.id} value={loc.id}>
                        {loc.genero}
                      </option>
                    ))}
                  </select>
                </InputGroup>
                {getFieldError("generoId") && (
                  <Form.Text className="text-danger">
                    {getFieldError("generoId")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Teléfono</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsFillTelephoneInboundFill />{" "}
                  </InputGroup.Text>
                  <input
                    type="tel"
                    placeholder="Digite su nombre"
                    name="dtelefono"
                    className="form-control"
                    value={formData.dtelefono}
                    onChange={handleChange}
                    required
                  ></input>
                </InputGroup>
                {getFieldError("dtelefono") && (
                  <Form.Text className="text-danger">
                    {getFieldError("dtelefono")}
                  </Form.Text>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-4">
                <label className="form-label">Correo (se usará como medio de seguimiento)</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text id="basic-addon1">
                    <BsFillEnvelopeAtFill />{" "}
                  </InputGroup.Text>
                  <input
                    type="email"
                    placeholder="Digite su correo"
                    name="dcorreo"
                    className="form-control"
                    value={formData.dcorreo}
                    onChange={handleChange}
                    required
                  ></input>
                </InputGroup>
                {getFieldError("dcorreo") && (
                  <Form.Text className="text-danger">
                    {getFieldError("dcorreo")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-2">
                <label className="form-label">Municipio</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text>
                    <BsFillPinMapFill />
                  </InputGroup.Text>
                  <select
                    className="form-control"
                    name="municipioId1"
                    value={formData.municipioId1}
                    onChange={handleMunicipioChange2}
                    required
                  >
                    <option value="">-- Selecciona Municipio --</option>
                    {municipios.map((mun) => (
                      <option key={mun.id} value={mun.id}>
                        {mun.municipio}
                      </option>
                    ))}
                  </select>
                </InputGroup>
                {getFieldError("municipioId1") && (
                  <Form.Text className="text-danger">
                    {getFieldError("municipioId1")}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={4}>
              <div className="form-group mb-2">
                <label className="form-label">Localidad</label>
                <InputGroup className="mb-1">
                  <InputGroup.Text>
                    <BsFillPinAngleFill />
                  </InputGroup.Text>
                  <select
                    name="localidadId2"
                    className="form-control"
                    value={formData.localidadId2}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Selecciona Localidad --</option>
                    {localidades2.map((loc) => (
                      <option key={loc.id} value={loc.id}>
                        {loc.localidad}
                      </option>
                    ))}
                  </select>
                </InputGroup>
                {getFieldError("localidadId2") && (
                  <Form.Text className="text-danger">
                    {getFieldError("localidadId2")}
                  </Form.Text>
                )}
              </div>
            </Col>
          </Row>
          <hr></hr>
          <label className="form-label">
            Apartado para Pruebas (en caso de no existir, omitir)
          </label>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>¿Tiene evidencia? click aquí</Accordion.Header>
              <Accordion.Body>
                <div className="form-group mb-4">
                  <b>Tipo Documental</b>.- Medio de prueba en documento o papel
                  para demostrar o acreditar la queja. <br />
                  <b>Testimonial</b>.- Documento que se rinde con la
                  intervención de testigos. Los testigos son las personas que
                  tienen conocimiento de los hechos que se desea probar(Anexarse
                  escrito signado por los testigos).
                  <br />
                  <b>Fotográfica</b>.- Fotos e imagenes.
                  <br />
                </div>
                <div className="form-group mb-4">
                  <font color="red">
                    <b>
                      Los nombres del Archivo no debe contener acentos ni tilde
                      o diéresis
                    </b>
                  </font>
                  <Form.Group controlId="images">
                    <Form.Label>
                      <b>Evidencia</b>
                    </Form.Label>
                    <InputGroup className="mb-1">
                      <InputGroup.Text>
                        <BsFillFloppy2Fill />
                      </InputGroup.Text>
                      <Form.Control
                        type="file"
                        onChange={handleFileChange}
                        ref={ref}
                        accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
                      />
                      <Button onClick={reset} className="btn-success">Limpiar selección</Button>
                    </InputGroup>
                    <Form.Text className="text-muted">
                      Formatos permitidos: JPG, PNG, PDF (Máximo 19 MB)
                    </Form.Text>
                  </Form.Group>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <hr></hr>
          <div className="form-group mb-4">
            <label className="form-label">
              ¿Desea recibir al correo electrónico proporcionado, material de
              difusión y concientización en materia de <b>Protección Civil</b>?
            </label>
            <Form.Check
              type="radio"
              label="Si"
              name="notificacion"
              value="Si"
              id="haveAccountRadios4"
              onChange={handleChange}
            />
            <Form.Check
              type="radio"
              label="No"
              name="notificacion"
              value="No"
              id="haveAccountRadios5"
              defaultChecked
              onChange={handleChange}
            />
          </div>
          <div className="mb-4">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6Ld0yIItAAAAALw0No0dLMbvyQ2NJTiduFmpBV45" // Reemplaza con tu clave real
              onChange={handleRecaptchaChange}
            />
            {submitAttempted && !recaptchaValue && (
              <Form.Text className="text-danger">
                Debes completar el reCAPTCHA
              </Form.Text>
            )}
          </div>
          <Button
            variant="success"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? " Enviando denuncia..." : "Enviar denuncia"}
          </Button>
        </form>
      </div>
      <FooterComponent />
    </div>
  );
};

export default AddQuejaComponent;
